import { AccountDrawerType, Address } from '@components/account/types'
import styles from './styles.module.scss'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'

export function AddressDetail({
  address,
  onHandleOpen
}: {
  address: Address & { defaultAddress: boolean }
  onHandleOpen: (type: AccountDrawerType, address: Address) => void
}) {
  const { address1, address2, city, zip, name, defaultAddress } = address || {}

  return (
    <address className={styles.AddressRow}>
      {defaultAddress && (
        <p className={styles.primaryAddress}>Primary Address</p>
      )}
      {name && <p>{name}</p>}
      {address1 && <p>{address1}</p>}
      {address2 && <p>{address2}</p>}
      {zip && <p>{zip}</p>}
      {city && <p>{city}</p>}
      <ButtonMinimal
        underlined={true}
        variant="primary"
        textSize="small"
        onClick={() => onHandleOpen('address', address)}
        classes={styles.AddressRowButton}
      >
        Edit
      </ButtonMinimal>
    </address>
  )
}
